export default function Footer() {
    return (
        <footer className="jcwa-footer">
            <div className="jcwa-footer-return">
                <a href="#main-content">Return to top</a>
            </div>
            <div className="jcwa-footer-secondary">
                <div className="jcwa-footer-logo">
                    <img
                        src="/Finality.png"
                        alt="Finality"
                    />
                </div>
                <div className="jcwa-footer-contact">
                    <a href="https://www.finalityllc.com/" target="_blank" rel="noreferrer">
                        https://www.finalityllc.com/
                    </a>
                    <p className="jcwa-footer-proprietary">
                        The JCWA ICAM and JCWA UNLOCK prototypes are Finality LLC Proprietary Information and should not be accessed or disclosed without written consent.  All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};
